import { isIOSEmbeddedAndStandalone } from '../../client';
import { callNative, requestTypes } from '../../lib/bridge';

class WinaAppPlugin {
  static getClientInfos = async () => {
    try {
      let result = null;

      // Sur iOS on fait un callNative qui va déclencher le webkitHandler et attendre la réponse via la promesse
      if (isIOSEmbeddedAndStandalone) {
        result = await callNative(requestTypes.GET_CLIENT_INFOS);

        return result?.data ?? {};
      }

      // Sinon, on regard si le plugin natif existe
      if (window.App && window.App.getClientInfos) {
        // @TODO: Attention à la rétrocompatibilitée lorsqu'on va release ça sur les clients Android pas à jour
        // Car ce plugin ne sera pas dispo, et pourtant, on sera bien en embedded
        result = await callNative(requestTypes.GET_CLIENT_INFOS);

        return result?.data ?? {};
      }
    } catch (e) {
      console.log('WinaAppPlugin plugin not available');
    }

    return null;
  };
}

export default WinaAppPlugin;
